// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"238": "07a17367","2862": "4dce220a","371": "b965dacc","7937": "0ff79880","9704": "07a17367",}[chunkId] + ".css"
}